import Communication from './communication';

export default Communication;
